import * as React from 'react';
import { BackwardCompatibleShareDialog } from './apiBackwardCompatilibity';
import type { BackwardCompatibleShareDialogProps } from './apiBackwardCompatilibity';

// This factory is only used in Boxfish, we only need backward compatibility for Boxfish
// After we updated Boxfish to use the new props structure, we can clean up the backward-compatibility file,
// and this factory can be made directly from the `ShareDialog` component provided by `share-dialog` package.
export const ShareDialogComponentFactory = React.createFactory<BackwardCompatibleShareDialogProps>(
    BackwardCompatibleShareDialog,
);
